module.exports = __webpack_public_path__ + "static/media/SB2.dab4b9b4.png";